import * as React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  Button,
  Card,
  CardContent,
  CircularProgress,
  FormControl,
  FormLabel,
  IconButton,
  RadioGroup,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import {
  ActivityAudience,
  IActivityAdd,
  IActivityEdit,
  IOrganization,
  ITeam,
  PublishState,
  TeamType,
  ThemeColor,
} from "utils/api.interfaces";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
// @ts-ignore
import JWPlayer from "@jwplayer/jwplayer-react";
import DialogTitle from "@mui/material/DialogTitle";
import { useNavigate, useParams } from "react-router-dom";
import { Transition } from "utils/common";
import FormControlLabel from "@mui/material/FormControlLabel";
import useTeams from "hooks/useTeams";
import AutocompleteDebounce from "components/AutocompleteDebounce";
import Radio from "@mui/material/Radio";
import useOrganizations from "../hooks/useOrganizations";
import ActivityFields from "../components/ActivityFields";
import useActivity, { putActivity } from "../hooks/useActivity";
import ButtonOrganization from "../components/ButtonOrganization";
import DeleteIcon from "@mui/icons-material/Delete";
import ButtonTeam from "../components/ButtonTeam";
import { ErrorMessageSlide } from "../components/ErrorMessageSlide";

export default function MingleActivityEdit() {
  const validationSchema = yup.object({
    content: yup.object({
      nl: yup.object({
        title: yup.string().required("Title is required"),
      }),
      en: yup.object({
        title: yup.string().required("Title is required"),
      }),
    }),
    activityAudience: yup.string(),
    // teamId: yup.string().when(["activityAudience"], {
    //   is: (activityAudience: string) => activityAudience === "team",
    //   then: yup.string().required("Please select a team"),
    // }),
    //
    // organizationId: yup.string().when("activityAudience", {
    //   is: (activityAudience: string) => activityAudience === "club",
    //   then: yup.string().required("Please select a club"),
    // }),
  });

  const navigate = useNavigate();

  const [newActivity, setNewActivity] = React.useState<boolean>(false);
  const [teamFilter, setTeamFilter] = React.useState<string>("");
  const { dataTeams } = useTeams({
    OrganizationIdFilter: "",
    TeamNameFilter: teamFilter,
    LeagueIdFilter: "",
    page: "0",
    pageSize: "999",
  });

  const [organizationFilter, setOrganizationFilter] =
    React.useState<string>("");
  const { dataOrganizations } = useOrganizations({
    NameFilter: organizationFilter,
    LeagueId: "",
    page: "0",
    pageSize: "99",
  });
  const { activityId } = useParams();
  const { dataActivity } = useActivity(activityId);
  const [activityTeamIds, setActivityTeamIds] = React.useState<string[]>([]);
  const hasLength = (arr: ITeam[] | IOrganization[]): boolean => {
    return arr && arr.length !== 0;
  };
  const [activityOrganizationIds, setActivityOrganizationIds] = React.useState<
    string[]
  >([]);
  console.log("temas = " + hasLength(dataActivity?.teams || []));
  console.log(
    "organizations = " + hasLength(dataActivity?.organizations || [])
  );
  const initActivity: IActivityAdd = {
    teams: activityTeamIds,
    organizations: activityOrganizationIds,
    shareWithFollowers: dataActivity?.shareWithFollowers || false,
    pinned: dataActivity?.pinned || false,
    activityAudience: hasLength(dataActivity?.teams || [])
      ? ActivityAudience.Team
      : hasLength(dataActivity?.organizations || [])
      ? ActivityAudience.Organization
      : ActivityAudience.All,
    sendPublishNotification: dataActivity?.sendPublishNotification || false,
    publishState: dataActivity?.publishState || PublishState.Draft,
    content: {
      nl: {
        title: dataActivity?.content.nl.title || "",
        contentTitle: dataActivity?.content.nl.contentTitle || "",
        contentBody: dataActivity?.content.nl.contentBody || "",
        pushNotificationContentTitle:
          dataActivity?.content.nl.pushNotificationContentTitle || "",
        pushNotificationContentBody:
          dataActivity?.content.nl.pushNotificationContentBody || "",

        button: {
          text: dataActivity?.content.nl.button?.text || "",
          url: dataActivity?.content.nl.button?.url || "",
          style: dataActivity?.content.nl.button?.style || ThemeColor.Primary,
        },
        mediaContent: {
          type: dataActivity?.content.nl.mediaContent?.type || "",
          imageName: dataActivity?.content.nl.mediaContent?.imageName || "",
          imageUrl: dataActivity?.content.nl.mediaContent?.imageUrl || "",
          videoUrl: dataActivity?.content.nl.mediaContent?.videoUrl || "",
          ThumbnailUrl:
            dataActivity?.content.nl.mediaContent?.ThumbnailUrl || "",
          sas: dataActivity?.content.nl.mediaContent?.sas || "",
        },
      },
      en: {
        title: dataActivity?.content.en.title || "",
        contentTitle: dataActivity?.content.en.contentTitle || "",
        contentBody: dataActivity?.content.en.contentBody || "",
        pushNotificationContentTitle:
          dataActivity?.content.nl.pushNotificationContentTitle || "",
        pushNotificationContentBody:
          dataActivity?.content.nl.pushNotificationContentBody || "",
        button: {
          text: dataActivity?.content.en.button?.text || "",
          url: dataActivity?.content.en.button?.url || "",
          style: dataActivity?.content.en.button?.style || ThemeColor.Primary,
        },
        mediaContent: {
          type: dataActivity?.content.en.mediaContent?.type || "",
          imageName: dataActivity?.content.en.mediaContent?.imageName || "",
          imageUrl: dataActivity?.content.en.mediaContent?.imageUrl || "",
          videoUrl: dataActivity?.content.en.mediaContent?.videoUrl || "",
          ThumbnailUrl:
            dataActivity?.content.en.mediaContent?.ThumbnailUrl || "",
          sas: dataActivity?.content.en.mediaContent?.sas || "",
        },
      },
    },
  };
  const [nlUseVideo, setNlUseVideo] = React.useState<boolean>(false);
  const [enUseVideo, setEnUseVideo] = React.useState<boolean>(false);
  const [editOrganizationAsABulk, setEditOrganizationAsABulk] =
    React.useState<boolean>(false);
  const [editTeamAsABulk, setEditTeamAsABulk] = React.useState<boolean>(false);
  const handleOrganizationChange = (
    event: React.ChangeEvent<unknown>,
    organization: IOrganization
  ) => {
    if (organization) {
      setActivityOrganizationIds((activityOrganizationIds) => [
        ...activityOrganizationIds,
        organization.id,
      ]);
    }
  };
  const deleteOrganizationActivity = (organizationId: string) => {
    if (organizationId) {
      setActivityOrganizationIds(
        activityOrganizationIds.filter((item) => item !== organizationId)
      );
    }
  };
  const handleTeamChange = (event: React.ChangeEvent<unknown>, team: ITeam) => {
    if (team) {
      setActivityTeamIds((activityTeamIds) => [...activityTeamIds, team.id]);
    }
  };
  const handleTeamInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const inputValue = event?.target.value
      .replace(/(\r\n|\n|\r)/gm, "")
      .replace(/ /g, "");
    setActivityTeamIds((activityTeamIds) => inputValue.split(","));
  };
  const handleOrganizationInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const inputValue = event?.target.value
      .replace(/(\r\n|\n|\r)/gm, "")
      .replace(/ /g, "");
    setActivityOrganizationIds((activityTeamIds) => inputValue.split(","));
  };
  const deleteTeamActivity = (teamId: string) => {
    if (teamId) {
      setActivityTeamIds(activityTeamIds.filter((item) => item !== teamId));
    }
  };

  const handleAudienceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setActivityOrganizationIds([]);
    setActivityTeamIds([]);
    formik.setFieldValue(
      "activityAudience",
      (event.target as HTMLInputElement).value
    );
  };
  React.useEffect(() => {
    formik.setFieldValue("organizations", activityOrganizationIds);
    // formik.setFieldValue("activityAudience", ActivityAudience.Organization);
  }, [activityOrganizationIds]);
  React.useEffect(() => {
    formik.setFieldValue("teams", activityTeamIds);
    // formik.setFieldValue("activityAudience", ActivityAudience.Team);
  }, [activityTeamIds]);

  React.useEffect(() => {
    if (Array.isArray(dataActivity?.teams) && dataActivity?.teams.length) {
      setActivityTeamIds(
        dataActivity?.teams.map((team: ITeam) => {
          return team.id;
        })
      );
      formik.setFieldValue("activityAudience", ActivityAudience.Team);
    }
    if (
      Array.isArray(dataActivity?.organizations) &&
      dataActivity?.organizations?.length
    ) {
      setActivityOrganizationIds(
        dataActivity?.organizations.map(
          (organization: IOrganization) => organization.id
        )
      );
      formik.setFieldValue("activityAudience", ActivityAudience.Organization);
    }
  }, [dataActivity]);
  const [showSlideError, setShowSlideError] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState<Boolean>(false);

  const formik = useFormik({
    initialValues: initActivity,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values: IActivityEdit) => {
      setIsLoading(true);
      putActivity(activityId, values)
        .then(() => {
          setNewActivity(true);
          setIsLoading(false);
        })
        .catch((e: any) => {
          setShowSlideError(true);
          setIsLoading(false);
        });
    },
  });
  React.useEffect(() => {
    if (!formik.isValid && formik.submitCount !== 0 && formik.isSubmitting) {
      if (!formik.isValid) {
        window.scrollTo(0, 0);
      }
    }
  }, [formik.submitCount, formik.isValid, formik.errors, formik.isSubmitting]);
  return (
    <>
      <Typography
        component="h1"
        variant="h1"
        color="inherit"
        noWrap
        gutterBottom
        sx={{
          textAlign: "center",
          margin: "40px 0px",
        }}
      >
        Update activity
      </Typography>
      <form onSubmit={formik.handleSubmit}>
        <Stack
          spacing={3}
          sx={{
            margin: "auto",
            opacity: newActivity || isLoading ? 0.4 : 1,
            pointerEvents: isLoading ? "none" : "auto",
          }}
        >
          <Stack>
            <Card sx={{ width: "100%", maxWidth: "850px", margin: " auto" }}>
              <CardContent>
                <Stack direction="column" spacing={4}>
                  <FormControl>
                    <FormLabel id="demo-controlled-radio-buttons-group">
                      This activity is for the following audience{" : "}
                      <strong>{formik.values.activityAudience}</strong>
                    </FormLabel>
                    {/*<RadioGroup*/}
                    {/*  aria-labelledby="demo-controlled-radio-buttons-group"*/}
                    {/*  onChange={handleAudienceChange}*/}
                    {/*  id="activityAudience"*/}
                    {/*  name="activityAudience"*/}
                    {/*  value={formik.values.activityAudience}*/}
                    {/*>*/}
                    {/*  <FormControlLabel*/}
                    {/*    value={ActivityAudience.All}*/}
                    {/*    control={<Radio />}*/}
                    {/*    label="For everybody"*/}
                    {/*  />*/}
                    {/*  <FormControlLabel*/}
                    {/*    value={ActivityAudience.Organization}*/}
                    {/*    control={<Radio />}*/}
                    {/*    label="For specific organization(s)"*/}
                    {/*  />*/}
                    {/*  <FormControlLabel*/}
                    {/*    value={ActivityAudience.Team}*/}
                    {/*    control={<Radio />}*/}
                    {/*    label="For specific team(s)"*/}
                    {/*  />*/}
                    {/*</RadioGroup>*/}
                  </FormControl>

                  {dataOrganizations &&
                    formik.values.activityAudience === "organization" && (
                      <>
                        <Stack direction="row" spacing={1} flexWrap="wrap">
                          <AutocompleteDebounce
                            handleChange={handleOrganizationChange}
                            data={dataOrganizations.organizations}
                            onFilterChange={(value) =>
                              setOrganizationFilter(value)
                            }
                            labelTitle="Add a organization"
                            formikErrors={formik.errors.organizations}
                            formikTouched={formik.touched.organizations}
                          />
                          <FormControlLabel
                            sx={{
                              margin: " 20px auto",
                            }}
                            control={
                              <Switch
                                checked={editOrganizationAsABulk}
                                inputProps={{ "aria-label": "controlled" }}
                                onChange={(e) => {
                                  e.target.checked
                                    ? setEditOrganizationAsABulk(true)
                                    : setEditOrganizationAsABulk(false);
                                }}
                              />
                            }
                            label="Edit raw value (to add organizations as a bulk)"
                          />
                        </Stack>
                        {editOrganizationAsABulk && (
                          <TextField
                            fullWidth
                            id={`organizationsBulk`}
                            name="organizationsBulk"
                            label="Organization raw comma seperated values"
                            value={activityOrganizationIds.join()}
                            multiline
                            rows={6}
                            maxRows={400}
                            onChange={handleOrganizationInputChange}
                          />
                        )}
                        <Stack direction="row" spacing={0} flexWrap="wrap">
                          {activityOrganizationIds.map((organizationId) => {
                            return (
                              <div key={organizationId}>
                                <ButtonOrganization
                                  organizationId={organizationId}
                                />
                                <IconButton
                                  aria-label="delete"
                                  color="error"
                                  onClick={(e) => {
                                    deleteOrganizationActivity(organizationId);
                                  }}
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </div>
                            );
                          })}
                        </Stack>
                      </>
                    )}

                  {dataTeams && formik.values.activityAudience === "team" && (
                    <>
                      <Stack direction="row" spacing={1} flexWrap="wrap">
                        <AutocompleteDebounce
                          handleChange={handleTeamChange}
                          data={dataTeams?.teams}
                          onFilterChange={(value) => setTeamFilter(value)}
                          labelTitle="Add a team"
                          formikErrors={formik.errors.teams}
                          formikTouched={formik.touched.teams}
                        />
                        <FormControlLabel
                          sx={{
                            margin: " 20px auto",
                          }}
                          control={
                            <Switch
                              checked={editTeamAsABulk}
                              inputProps={{ "aria-label": "controlled" }}
                              onChange={(e) => {
                                e.target.checked
                                  ? setEditTeamAsABulk(true)
                                  : setEditTeamAsABulk(false);
                              }}
                            />
                          }
                          label="Edit raw value (to add teams as a bulk)"
                        />
                      </Stack>
                      {editTeamAsABulk && (
                        <TextField
                          fullWidth
                          id={`teamsBulk`}
                          name="teamsBulk"
                          label="Teams raw value"
                          value={activityTeamIds.join()}
                          multiline
                          rows={6}
                          maxRows={400}
                          onChange={handleTeamInputChange}
                        />
                      )}
                      <Stack direction="row" spacing={0} flexWrap="wrap">
                        {activityTeamIds.map((teamId) => {
                          return (
                            <div key={teamId}>
                              <ButtonTeam variant="outlined" teamId={teamId} />
                              <IconButton
                                color="error"
                                aria-label="delete"
                                onClick={(e) => {
                                  deleteTeamActivity(teamId);
                                }}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </div>
                          );
                        })}
                      </Stack>
                      <FormControlLabel
                        sx={{
                          margin: " 20px auto",
                        }}
                        control={
                          <Switch
                            checked={formik.values.shareWithFollowers}
                            inputProps={{ "aria-label": "controlled" }}
                            value={formik.values.shareWithFollowers}
                            onChange={(e) => {
                              e.target.checked
                                ? formik.setFieldValue(
                                    "shareWithFollowers",
                                    true
                                  )
                                : formik.setFieldValue(
                                    "shareWithFollowers",
                                    false
                                  );
                            }}
                          />
                        }
                        label="Activity is shared with followers"
                      />
                    </>
                  )}

                  <hr />
                  <FormControlLabel
                    sx={{
                      margin: " 20px auto",
                    }}
                    control={
                      <Switch
                        checked={formik.values.pinned}
                        inputProps={{ "aria-label": "controlled" }}
                        value={formik.values.pinned}
                        onChange={(e) => {
                          e.target.checked
                            ? formik.setFieldValue("pinned", true)
                            : formik.setFieldValue("pinned", false);
                        }}
                      />
                    }
                    label="Activity is pinned in the feed"
                  />
                  <FormControlLabel
                    sx={{
                      margin: " 20px auto",
                    }}
                    control={
                      <Switch
                        checked={
                          formik.values.publishState === PublishState.Published
                        }
                        inputProps={{ "aria-label": "controlled" }}
                        value={formik.values.pinned}
                        onChange={(e) => {
                          e.target.checked
                            ? formik.setFieldValue(
                                "publishState",
                                PublishState.Published
                              )
                            : formik.setFieldValue(
                                "publishState",
                                PublishState.Draft
                              );
                        }}
                      />
                    }
                    label="Activity is published"
                  />

                  <FormControlLabel
                    sx={{
                      margin: " 20px auto",
                    }}
                    control={
                      <Switch
                        disabled={dataActivity?.sendPublishNotification}
                        checked={formik.values.sendPublishNotification}
                        inputProps={{ "aria-label": "controlled" }}
                        value={formik.values.sendPublishNotification}
                        onChange={(e) => {
                          e.target.checked
                            ? formik.setFieldValue(
                                "sendPublishNotification",
                                true
                              )
                            : formik.setFieldValue(
                                "sendPublishNotification",
                                false
                              );
                        }}
                      />
                    }
                    label="Send push notification"
                  />
                  {formik.values.sendPublishNotification &&
                    !dataActivity?.sendPublishNotification && (
                      <Typography
                        variant="body2"
                        color="error"
                        sx={{
                          transform: "translate(58px,-34px)",
                          whiteSpace: "pre-line",
                          display: "inline-block",
                        }}
                      >
                        Please check if the audience above is set correctly,
                        with great power comes great responsibility ;-)
                      </Typography>
                    )}
                  <hr />
                  <Stack direction="row" spacing={4}>
                    <div style={{ width: "50%" }}>
                      <ActivityFields formik={formik} lang="nl" />

                      {formik.values.content.nl.mediaContent?.imageUrl && (
                        <>
                          <img
                            src={
                              formik.values.content.nl.mediaContent?.imageUrl
                            }
                            style={{ width: "392px", height: "auto" }}
                          />
                          {/*<Button*/}
                          {/*  color="secondary"*/}
                          {/*  variant="outlined"*/}
                          {/*  size="small"*/}
                          {/*  fullWidth*/}
                          {/*  onClick={() => {*/}
                          {/*    formik.setFieldValue(*/}
                          {/*      "content.nl.mediaContent.imageUrl",*/}
                          {/*      ""*/}
                          {/*    );*/}
                          {/*    formik.setFieldValue(*/}
                          {/*      "content.nl.mediaContent.imageName",*/}
                          {/*      ""*/}
                          {/*    );*/}
                          {/*    formik.setFieldValue(*/}
                          {/*      "content.nl.mediaContent.type",*/}
                          {/*      ""*/}
                          {/*    );*/}
                          {/*  }}*/}
                          {/*>*/}
                          {/*  remove image*/}
                          {/*</Button>*/}
                        </>
                      )}
                      {formik.values.content?.nl.mediaContent?.videoUrl && (
                        <>
                          <JWPlayer
                            file={`${formik.values.content?.nl.mediaContent?.videoUrl}`}
                            library="https://cdn.jwplayer.com/libraries/wyHeWRqG.js"
                          />

                          {/*<Button*/}
                          {/*  color="secondary"*/}
                          {/*  variant="outlined"*/}
                          {/*  size="small"*/}
                          {/*  fullWidth*/}
                          {/*  onClick={() => {*/}
                          {/*    formik.setFieldValue(*/}
                          {/*      "content.nl.mediaContent.videoUrl",*/}
                          {/*      ""*/}
                          {/*    );*/}
                          {/*    formik.setFieldValue(*/}
                          {/*      "content.nl.mediaContent.ThumbnailUrl",*/}
                          {/*      ""*/}
                          {/*    );*/}
                          {/*    formik.setFieldValue(*/}
                          {/*      "content.nl.mediaContent.sas",*/}
                          {/*      ""*/}
                          {/*    );*/}
                          {/*    formik.setFieldValue(*/}
                          {/*      "content.nl.mediaContent.type",*/}
                          {/*      ""*/}
                          {/*    );*/}
                          {/*  }}*/}
                          {/*>*/}
                          {/*  remove video*/}
                          {/*</Button>*/}
                        </>
                      )}
                    </div>

                    <div style={{ width: "50%" }}>
                      <ActivityFields formik={formik} lang="en" />

                      {formik.values.content.en.mediaContent?.imageUrl && (
                        <>
                          <img
                            src={
                              formik.values.content.en.mediaContent?.imageUrl
                            }
                            style={{ width: "392px", height: "auto" }}
                          />
                          {/*<Button*/}
                          {/*  color="secondary"*/}
                          {/*  variant="outlined"*/}
                          {/*  size="small"*/}
                          {/*  fullWidth*/}
                          {/*  onClick={() => {*/}
                          {/*    formik.setFieldValue(*/}
                          {/*      "content.en.mediaContent.imageUrl",*/}
                          {/*      ""*/}
                          {/*    );*/}
                          {/*    formik.setFieldValue(*/}
                          {/*      "content.en.mediaContent.imageName",*/}
                          {/*      ""*/}
                          {/*    );*/}
                          {/*    formik.setFieldValue(*/}
                          {/*      "content.en.mediaContent.type",*/}
                          {/*      ""*/}
                          {/*    );*/}
                          {/*  }}*/}
                          {/*>*/}
                          {/*  remove image*/}
                          {/*</Button>*/}
                        </>
                      )}
                      {formik.values.content?.en.mediaContent?.videoUrl && (
                        <>
                          <JWPlayer
                            file={`${formik.values.content?.en.mediaContent?.videoUrl}`}
                            library="https://cdn.jwplayer.com/libraries/wyHeWRqG.js"
                          />

                          {/*<Button*/}
                          {/*  color="secondary"*/}
                          {/*  variant="outlined"*/}
                          {/*  size="small"*/}
                          {/*  fullWidth*/}
                          {/*  onClick={() => {*/}
                          {/*    formik.setFieldValue(*/}
                          {/*      "content.en.mediaContent.videoUrl",*/}
                          {/*      ""*/}
                          {/*    );*/}
                          {/*    formik.setFieldValue(*/}
                          {/*      "content.en.mediaContent.ThumbnailUrl",*/}
                          {/*      ""*/}
                          {/*    );*/}
                          {/*    formik.setFieldValue(*/}
                          {/*      "content.en.mediaContent.sas",*/}
                          {/*      ""*/}
                          {/*    );*/}
                          {/*    formik.setFieldValue(*/}
                          {/*      "content.en.mediaContent.type",*/}
                          {/*      ""*/}
                          {/*    );*/}
                          {/*  }}*/}
                          {/*>*/}
                          {/*  remove video*/}
                          {/*</Button>*/}
                        </>
                      )}
                    </div>
                  </Stack>
                </Stack>
              </CardContent>
            </Card>
          </Stack>

          <Button
            color="secondary"
            variant="contained"
            fullWidth
            type="submit"
            endIcon={
              isLoading && (
                <IconButton aria-label="" edge="end">
                  <CircularProgress
                    size={15}
                    sx={{ color: "#68F3CB" }}
                    color="success"
                  />
                </IconButton>
              )
            }
          >
            Update Activity
          </Button>
          <ErrorMessageSlide showError={showSlideError} />
        </Stack>

        <Dialog
          open={newActivity}
          TransitionComponent={Transition}
          keepMounted
          onClose={() => {
            setNewActivity(false);
          }}
          aria-describedby="alert-dialog-slide-description"
          PaperProps={{
            sx: { backgroundColor: "#fff", minWidth: "400px" },
          }}
        >
          <DialogTitle variant="h4">
            {"Activity successfully updated!"}
          </DialogTitle>

          <DialogActions>
            <Button
              size="small"
              onClick={() => {
                setNewActivity(false);
              }}
            >
              close
            </Button>
            <Button
              size="small"
              color="secondary"
              variant="outlined"
              onClick={() => navigate(`/activity/${activityId}`)}
            >
              Go to activity page
            </Button>
          </DialogActions>
        </Dialog>
      </form>
    </>
  );
}
